import { Container, Flex, Stack, Image, Heading, Text, Link, HStack } from '@chakra-ui/react'
import ProfileSvg from '../assets/profile.svg'
const About = () => {
  return (
    <Container maxW={'5xl'} bg={'gray.50'}>
      <Stack
        textAlign={'center'}
        align={'center'}
        spacing={{ base: 8, md: 10 }}
        py={{ base: 20, md: 28 }}
      >
        <Flex w={'full'} alignItems={'center'} justifyContent={'center'}>
          <Image src={ProfileSvg} boxSize={'sm'} />
        </Flex>
        <Heading>Srikanth Alva</Heading>
        <Text>Full Stack Web3 Developer</Text>
        <HStack>
          <Link href={'https://linkedin.com/in/srikanthalva'}>LinkedIn</Link>
          <Link href={'https://twitter.com/SrikanthAlva'}>Twitter</Link>
        </HStack>
        <Text>
          Hello, this is Srikanth, a Full Stack Blockchain Developer at the forefront of the
          decentralized revolution. With a deep passion for cutting-edge technology and a knack for
          problem-solving, I strive towards implementating secure, scalable, and efficient
          blockchain solutions.
          <br /> <br />
          Welcome to SubtleWeb3! I am an imaginative and versatile Full Stack Blockchain Developer
          with a passion for pushing the boundaries of what's possible in the decentralized world.
          With a keen eye for detail and a love for elegant code, I specialize in crafting
          innovative solutions that harness the power of blockchain technology. <br /> <br /> My
          journey in blockchain began with a fascination for its potential to revolutionize
          industries and empower individuals. Since then, I have embarked on a mission to explore
          the vast possibilities that lie within this transformative technology. From designing and
          deploying smart contracts to developing intuitive decentralized applications, I thrive on
          creating solutions that seamlessly integrate blockchain into the fabric of everyday life.{' '}
          <br /> <br />
          As a creative problem-solver, I believe in the power of collaboration and teamwork. I have
          had the pleasure of working with cross-functional teams, where I have leveraged my
          expertise in front-end and back-end development to build robust and scalable blockchain
          systems. My ability to communicate complex ideas in simple terms has allowed me to bridge
          the gap between technical and non-technical stakeholders, fostering a shared vision and
          driving successful project outcomes. <br /> <br /> My portfolio showcases a diverse range
          of projects, each with its own unique challenge and solution. Whether it's building secure
          and transparent supply chain networks, revolutionizing digital identity verification, or
          exploring the potential of decentralized finance, I am committed to creating meaningful
          and impactful solutions that address real-world problems. <br /> <br />
          Constantly staying abreast of the latest advancements in blockchain technology, I am an
          avid learner and an advocate for continuous growth. By exploring emerging trends and
          experimenting with cutting-edge tools and frameworks, I am always seeking new ways to push
          the boundaries of what can be achieved in the decentralized space. <br /> <br /> I invite
          you to explore my portfolio and witness firsthand the power of blockchain unleashed
          through elegant and efficient code. Together, let's embark on a journey towards a
          decentralized future where trust, transparency, and innovation reign supreme. Thank you
          for visiting, and I look forward to connecting with you soon.
        </Text>

        {/* <Text>
          NFT Contract 1. Skullios 2. Skhulls 3. AI Centurain 4. Seeds of Knowledge Soul Bound
          Tokens 1. Souls of Knowledge Web3 Integration for Games 1. Tavern by EgoVerse 1. Academia
        </Text> */}
      </Stack>
    </Container>
  )
}
export default About
